import api from './axios'

export const getReport = async() => {
  const res = await api.get("users/report")
  return res.data
}